import { QuestionPlanIsHiddenHotelQuestions } from "./is-hidden-hotel-questions";
import { QuestionPlanPreQuestions } from "./pre-questions/pre-questions";

export const QuestionPlanPreQuestionsRoot = () => {
	return (
		<>
			<QuestionPlanIsHiddenHotelQuestions />
			<QuestionPlanPreQuestions />
		</>
	);
};

QuestionPlanPreQuestionsRoot.displayName = "QuestionPlanPreQuestionsRoot";
